import React, { useEffect, useState } from 'react';
import './DogEar.scss';

const DogEar = (props) => {
    const imageMap = {
        fill:{
            left: "url('media/img/buttons/tab-border-images/border-image-fill-left.png')",
            center: "url('media/img/buttons/tab-border-images/border-image-fill-center.png')",
            right: "url('media/img/buttons/tab-border-images/border-image-fill-right.png')",
            only: "url('media/img/buttons/tab-border-images/border-image-fill-button.png')"
        },
        line:{
            left: "url('media/img/buttons/tab-border-images/border-image-line-left.png')",
            center: "url('media/img/buttons/tab-border-images/border-image-line-center.png')",
            right: "url('media/img/buttons/tab-border-images/border-image-line-right.png')",
            only: "url('media/img/buttons/tab-border-images/border-image-line-button.png')"
        }
    }
    const imageStyle = props.selected ? imageMap.fill : imageMap.line;
    let siblingType = "only";
    if ( (props.length || 0) > 1 ) {
        siblingType = "center";
        if(props.index == 0) {
            siblingType = "left";
        }
        if(props.index == props.length-1) {
            siblingType = "right"
        }
    };
    return (<div {...props}
                className={`reusable-dogear ${props.selected ? 'selected' : ''} ${props.visited ? 'visited' : ''} ${props.className || ''}`}
                style={{...props.style, borderImageSource: imageStyle[siblingType]}}
           >
        {props.children}
        
    </div>)
}
export default DogEar;
